import { useNavigate } from 'react-router-dom';

const WebdesignPortfolio = () => {
  const navigate = useNavigate();
  const projects = [
    {
      id: 2,
      title: "dionbamme.de",
      description: "Persönliche Portfolio-Website mit modernem Design und optimaler Performance. Responsive Design für alle Endgeräte.",
      image: "https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/7f350581e32b767ec67dd8ab2d20d41b.png",
      tags: ["Portfolio", "Responsive Design", "Performance"],
      category: "Website",
      url: "https://www.dionbamme.de"
    },
    {
      id: 3,
      title: "Allroundservice Website",
      description: "Professionelle Unternehmenswebsite für einen Allroundservice-Anbieter mit umfassendem Leistungsportfolio.",
      image: "https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/09bc803c235b90e5e9a3fb3111494311.png",
      tags: ["Business Website", "Service Portfolio", "SEO"],
      category: "Website",
      url: "https://www.jo-allround.de"
    },
    {
      id: 4,
      title: "Tischlerei Hasenbalg",
      description: "Professionelle Handwerker-Website für eine traditionelle Tischlerei – mit Leistungsübersicht, Galerie und lokalem SEO für maximale Sichtbarkeit in der Region.",
      image: "https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/ed60fbb1b5dd421526b2b69ca0d1f9b1.jpeg",
      tags: ["Handwerk", "Local SEO", "Galerie"],
      category: "Website",
      url: ""
    },
    {
      id: 5,
      title: "Heizung & Sanitär Firma",
      description: "Moderne Website für ein Heizungs- und Sanitärunternehmen mit Fokus auf lokale Suchmaschinenoptimierung.",
      image: "https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/8d64f3f8e622b739eec0c23a521864ff.png",
      tags: ["Handwerk", "Local SEO", "Kontaktformular"],
      category: "Website"
    }
  ];

  const handleProjectClick = (project: typeof projects[0], index: number) => {
    if (index === 0) {
      window.open("https://www.dionbamme.de", "_blank");
    } else if (index === 1) {
      window.open("https://www.jo-allround.de", "_blank");
    }
  };

  return (
    <section id="portfolio" className="py-32 bg-black">
      <div className="container mx-auto px-6">
        <div className="text-center mb-20">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <div className="w-2 h-2 bg-[#d1bc8a] rounded-full"></div>
            <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-light">Portfolio</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 tracking-tight">
            Unsere Webdesign<br />Projekte
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto font-light">
            Entdecken Sie eine Auswahl unserer erfolgreich umgesetzten Webprojekte
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {projects.map((project, index) => (
            <div
              key={project.id}
              className="bg-zinc-900 border border-zinc-800 overflow-hidden hover:border-[#d1bc8a] transition-all duration-300 group cursor-pointer"
              onClick={() => handleProjectClick(project, index)}
            >
              <div className="relative overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-64 object-cover grayscale group-hover:grayscale-0 transition-all duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"></div>
                
                <div className="absolute top-6 left-6">
                  <span className="bg-[#d1bc8a] text-black px-4 py-1 text-xs font-medium uppercase tracking-wider">
                    {project.category}
                  </span>
                </div>

                <div className="absolute bottom-6 right-6 z-10">
                  <h3
                    className="text-2xl lg:text-3xl text-white drop-shadow-lg"
                    style={{
                      fontFamily: '"Anton", sans-serif',
                      fontWeight: "normal"
                    }}
                  >
                    {project.title}
                  </h3>
                </div>

                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500 bg-black/60">
                  <div className="bg-[#d1bc8a] text-black px-6 py-3 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                    <span className="font-medium flex items-center text-sm uppercase tracking-wider">
                      {(project.title === "Heizung & Sanitär Firma" || project.title === "Tischlerei Hasenbalg") ? (
                        <>
                          <i className="ri-time-line mr-2"></i>
                          Coming Soon
                        </>
                      ) : (
                        <>
                          <i className="ri-eye-line mr-2"></i>
                          Projekt ansehen
                        </>
                      )}
                    </span>
                  </div>
                </div>
              </div>

              <div className="p-6">
                <p className="text-gray-400 mb-4 line-clamp-3 font-light">
                  {project.description}
                </p>

                <div className="flex flex-wrap gap-2">
                  {project.tags.map((tag, tagIndex) => (
                    <span
                      key={tagIndex}
                      className="bg-black border border-zinc-800 text-gray-400 px-3 py-1 text-xs uppercase tracking-wider"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <button
            onClick={() => navigate('/kontakt')}
            className="bg-[#d1bc8a] text-black px-10 py-4 font-medium rounded-none hover:bg-white transition-all duration-300 whitespace-nowrap cursor-pointer text-sm tracking-wider uppercase"
          >
            Jetzt Projekt starten
          </button>
        </div>
      </div>
    </section>
  );
};

export default WebdesignPortfolio;